export type ExistingMetricColumn = {
  value: string;
  disabled?: boolean;
};

export const findFirstOrderByMatch = (values: unknown[], candidates: string[]) => {
  return candidates.find((candidate) => {
    return values.find((value) => value === candidate);
  });
};

export const resolveReportOrderBy = (options: {
  values: unknown[];
  defaultSort?: string[];
  existingMetrics: ExistingMetricColumn[];
  sortExclude: string[];
}) => {
  if (options.defaultSort?.length) {
    const fromDefaultSort = findFirstOrderByMatch(options.values, options.defaultSort);
    if (fromDefaultSort) {
      return fromDefaultSort;
    }
  }

  const enabledMetricValues = options.existingMetrics
    .filter((item) => !item.disabled && !options.sortExclude.includes(item.value))
    .map((item) => item.value);
  const fromEnabledMetrics = findFirstOrderByMatch(options.values, enabledMetricValues);
  if (fromEnabledMetrics) {
    return fromEnabledMetrics;
  }

  const disabledMetricValues = options.existingMetrics
    .filter((item) => item.disabled)
    .map((item) => item.value);

  return findFirstOrderByMatch(options.values, disabledMetricValues);
};
